import { render, staticRenderFns } from "./RosterActiveFilters.vue?vue&type=template&id=86a5f6f6&"
import script from "./RosterActiveFilters.vue?vue&type=script&lang=js&"
export * from "./RosterActiveFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports